// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import VueCookies from 'vue-cookie' //REMOVE!
// import VueSession from 'vue-session'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './storage'
import api from './js/api'
import {BusEmisor} from './js/BusEmisor'
import stripe from "./js/stripe"
import vueStep from 'vue-step' //Using in CV
import responsive from 'vue-responsive' //Responsive
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/app.scss'

import swal from 'sweetalert';
import VueScrollTo from 'vue-scrollto';
import VueResizeText from 'vue-resize-text';
//open-V2-changes ::
import TheSectionContent from '@/components/TheSectionContent.vue'
import Spinner from 'vue-simple-spinner'
import Vuelidate from 'vuelidate'
import VueLetterAvatar from 'vue-letter-avatar'
import Vue2Filters from "vue2-filters";
import Overlay from '@/components/TheOverlay'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import VueSingleSelect from "vue-single-select";
import Places from 'vue-places'
import Multiselect from 'vue-multiselect'
import VueContentPlaceholders from 'vue-content-placeholders'
import VueEditor from "vue2-editor"
import VueMoment from 'vue-moment'
import Media from '@dongido/vue-viaudio'
import SocialSharing from 'vue-social-sharing'
import PDF from 'vue-pdf'
import Clipboard from 'v-clipboard'
import VueNumeric from 'vue-numeric'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import FBSignInButton from 'vue-facebook-signin-button'
import VueAuthenticate from 'vue-authenticate'
import VueHtmlToPaper from 'vue-html-to-paper';
import VueMask from 'v-mask'
import {ValidationProvider} from 'vee-validate';
//Student
import CurriculumFull from '@/components/#pages/profile/page/Curriculum'
import CurriculumPreview from '@/components/#pages/candidates/components/CurriculumPreview'
import CreditCard from '@/components/#public/payments/CreditCard'
import VueIntro from 'vue-introjs';
import 'intro.js/introjs.css';
import TableEmpty from "./components/utils/TableEmpty";
import 'intro.js/themes/introjs-modern.css'; 
import VueCarousel from '@chenfengyuan/vue-carousel';
import VueVideoPlayer from 'vue-video-player'
// require videojs style
import 'video.js/dist/video-js.css'
import Pusher from "pusher-js";
import VueGeolocation from 'vue-browser-geolocation';

import InitController from "./js/connection/init"
import events from "./events";
import VueToast from 'vue-toast-notification';

import detectMobile from "./DetecMobile";

Vue.component('section-content', TheSectionContent)

Vue.component('vue-simple-spinner', Spinner)

Vue.use(Vuelidate)
Vue.use(VueToast)
Vue.use(VueGeolocation);
Vue.use(VueLetterAvatar);

Vue.use(Vue2Filters)

Vue.component('overlay', Overlay)
Vue.component('TableEmpty', TableEmpty);

Vue.component('v-select', vSelect)


Vue.use(VueResizeText)

Vue.use(VueCarousel);
// Or
Vue.component(VueCarousel.name, VueCarousel);
// Or
Vue.component('vue-carousel', VueCarousel);

const moment = require('moment')
require('moment/locale/es')

Vue.component(swal)

Vue.component('places', Places)
Vue.component('CurriculumFull', CurriculumFull)
Vue.component('CreditCard', CreditCard)
Vue.component('CurriculumPreview', CurriculumPreview)
Vue.component('multiselect', Multiselect)
Vue.component('vue-editor', VueEditor)
Vue.component('Media', Media)
Vue.component('pdf', PDF)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(VueIntro);

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.css',
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    'https://use.fontawesome.com/1157712716.css',
    'https://use.fontawesome.com/28a29ce817.js',
    './assets/css/cv.css',
    'https://dev.kllaar.com/static/css/cv.css',
  ]
}
Vue.use(VueHtmlToPaper,options);
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueNumeric)
Vue.use(SocialSharing);
Vue.use(Media)
Vue.use(CurriculumFull)
Vue.use(CurriculumPreview)
Vue.use(BootstrapVue)
Vue.use(VueMask) //Documentation::: https://www.npmjs.com/package/v-mask
Vue.use(VueContentPlaceholders) //Documentation::: https://github.com/michalsnik/vue-content-placeholders
Vue.use(Clipboard) //Documentation::: https://www.npmjs.com/package/v-clipboard
Vue.use(VueMoment, { //https://www.npmjs.com/package/vue-moment
  moment
})
Vue.use(responsive)


Vue.filter('timeDate', function (created) {
  return moment(created).format('MMMM DD/YYYY hh:mm a');
})
Vue.filter('timeDateHummand', function (created) {
  return moment(created).fromNow(true)
})


Vue.filter('striphtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});




// import GoogleAutocomplete from 'google-autocomplete-vue';
// Vue.component('google-autocomplete', GoogleAutocomplete);


// Vue.use(VueCookies);
// Vue.use(VueSession, options)


// Vue.use(require('vue-moment'));
// Vue.use(VueGoogleAutocomplete)

Vue.config.productionTip = false
Vue.prototype.$appDebug = false //TODO: Mostrar contenidos de los formularios!
Vue.prototype.$api = api;
Vue.prototype.$bus = BusEmisor;
Vue.prototype.$events = events;
Vue.prototype.$places = Places;
Vue.prototype.$slider = VueScrollTo;
Vue.prototype.$stripe = stripe;
Vue.prototype.$mobile = detectMobile;
//
var pusher = new Pusher('eedcc08129002c0815d5', {
  cluster: 'us2',
  encryped: true,
  forceTLS: true
});

Vue.prototype.$pusher = pusher;


Object.defineProperty(Vue.prototype, 'api', {value: api})
Object.defineProperty(Vue.prototype, 'bus', {value: BusEmisor})
Object.defineProperty(Vue.prototype, 'slider', {value: VueScrollTo})

Vue.use(VueAuthenticate, {
  baseUrl: 'https://api.kllaar.com/api/', // Your API domain
  providers: {
    facebook: {
      clientId: '1107667729623790',
      clientSecret: '7329b224fe5c6ed51099f001186d65b8',
      redirectUri: 'https://api.kllaar.com/api/auth/callback/facebook' // Your client app URL
    }
  }
})


//TokenData
const token = localStorage.getItem('access_token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

//Components::
Vue.component('vueStep', vueStep); //Documentation::: https://www.npmjs.com/package/vue-step
Vue.component('vue-single-select', VueSingleSelect); //Documentation::: https://vuejsexamples.com/single-select-dropdown-with-autocomplete/
// import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)


import VueSwal from 'vue-swal';

Vue.use(VueSwal);
//Definir inicio de sesion y otras cosas
InitController.start();

const app = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})
//Instancia de la aplicacion

// const app = new Vue({
// 	router,
// 	store,
// 	render: h => h(App),
// }).$mount('#app');


export default app



// WEBPACK FOOTER //
// ./src/main.js